import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers"

export const app = Application.start()

const controllers = import.meta.glob("./**/*_controller.{js,ts}", { eager: true })
registerControllers(app, controllers)
